package com.karawek.core.ui.components

import androidx.compose.foundation.clickable
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CoreTextButton(
    text: String,
    style: TextStyle = CoreTypography.body,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    onClick: () -> Unit,
) {
    val colors = CoreTheme.colors

    Text(
        text = text,
        modifier = modifier.clickable(enabled = enabled, onClick = onClick),
        style = style,
        color = if (enabled) colors.primary else colors.primary.copy(alpha = CoreAlphas.Disabled),
    )
}
